import { Stars } from "@/public/assets";

interface Props {
  message?: string;
}
const ComingSoon = ({
  message = "Get ready for a smoother, faster experience - our web app is launching soon!",
}: Props) => {
  return (
    <div className="flex flex-col items-center pt-10 md:pt-20 px-4">
      <div className="w-full max-w-2xl mb-6 md:mb-8 bg-[#E9FBF2] rounded-3xl md:rounded-full flex flex-col md:flex-row items-center p-4 md:p-0">
        {/* Button - centered on mobile, left-aligned on desktop */}
        <button className="bg-[#1FC16B] text-white text-sm font-medium px-2 py-0.5 rounded-full flex items-center justify-center gap-2  md:my-1 md:ml-1  ">
          <img alt="Stars" className="h-3 w-3" src={Stars.src} />
          <span className=" whitespace-nowrap text-[14px]">Coming soon</span>
        </button>

        {/* Text - centered below on mobile, inline on desktop */}
        <span className="text-[#178C4E] text-sm text-center md:text-left md:px-2 md:py-2">
          {message}
        </span>
      </div>
    </div>
  );
};

export default ComingSoon;
